import { isStrongPassword } from "validator";
export const isPassword = (password: any) =>
  isStrongPassword(password, {
    minLength: 8,
    minSymbols: 1,
    minLowercase: 1,
    returnScore: false,
  });
